import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  vmDataService,
} from 'app/services';
import controller from './edit-insurance-comment-dialog.controller';
import template from './edit-insurance-comment-dialog.html';
import commentTextMessagesTpl from './messages/comment.text.messages.html';

class dialogService {
  getOptions($event, { productInsuranceComment, addCallback, editCallback }) {
    return {
      controller,
      controllerAs: 'editInsuranceCommentDialogVM',
      locals: {
        productInsuranceComment,
        addCallback,
        editCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.editInsuranceCommentDialog', [
  constants,
  loaderService,
  ssDialogService,
  vmDataService,
])
  .service('editInsuranceCommentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('comment.text.messages.html', commentTextMessagesTpl);
  })
  .name;
